import { render } from "./VerifiedView.vue?vue&type=template&id=958cc266&scoped=true"
import script from "./VerifiedView.vue?vue&type=script&lang=js"
export * from "./VerifiedView.vue?vue&type=script&lang=js"

import "./VerifiedView.vue?vue&type=style&index=0&id=958cc266&scoped=true&lang=css"

import exportComponent from "/Users/abinop/code/Filisia-Dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-958cc266"]])

export default __exports__